/*
 * @Author: niuqingxia
 * @Date: 2024-12-19 17:53:01
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-12-Th 09:41:17
 柱状图（纵向）
 */

<template>
  <div class="bar-chart" :style="{width: config.chartWidth+'px',height:config.chartHeight+'px'}">
    <div class="bar-chart-wrapper">
      <img v-if="borderImgUrl" class="bar-chart-border" :src="borderImgUrl" alt=""
           :style="{
             display:'inline-block',
             width:'100%',
             height: '100%'
           }">
      <div class="bar-chart-title" :style="{
        width:'100%',
        textAlign: style.titleStyle.align,
        fontSize: style.titleStyle.fontSize + 'px',
        color: style.titleStyle.color,}">
        {{ config.chartTitle }}
        <el-tooltip v-if="config.chartViewData.showIndicator" class="item" :open-delay="500" effect="dark" placement="top">
          <div slot="content" v-html="indicatorDescription"></div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
    </div>
    <div ref="barChart" class="bar-chart-container"></div>
  </div>
</template>

<script>
import _ from 'lodash'

import * as echarts from 'echarts'
import { COLOR_LIST } from '@/utils/defaultColorData'
import { imgURLtoBase64 } from '@/utils/common'
import { horizonBarBaseOption, polarBarBaseOption, verticalBarBaseOption } from './options'
import ChartMixin from './mixin'

export default {
  mixins: [ChartMixin],

  data () {
    return {
    }
  },
  computed: {
    style () {
      return this.config.chartSet
    },
    chartData () {
      return this.config.chartViewData.chartData
    },
    // 维度
    dataAxis () {
      const list = []
      if (this.chartData?.length && Array.isArray(this.chartData)) {
        const colKeyList = Object.keys(this.chartData[0])
        this.chartData.slice(1).forEach(bar => {
          list.push(bar[colKeyList[0]]) // 第一列数据(维度)
        })
        return list
      } else {
        return []
      }
    },
    // 数据
    series () {
      const list = []
      let initItem = {}
      if (this.componentType === 'barPolar') {
        initItem = {
          type: 'bar',
          data: [],
          coordinateSystem: 'polar',
          label: {
            show: this.style.chartStyle.isLabel,
            position: 'middle',
            formatter: '{b}: {c}',
          },
        }
      } else {
        const radius = this.style.chartStyle.borderRadius
        initItem = {

          name: '',
          type: 'bar',
          barGap: '30%',
          label: {
            show: this.style.chartStyle.isLabel,
            position: this.componentType === 'horizonBar' ? 'right' : 'top',
            color: '#D0D5E0',
            fontSize: this.style.chartStyle.fontSize,
          },
          barWidth: this.style.chartStyle.borderWidth,
          itemStyle: {
            borderRadius: this.componentType === 'horizonBar' ? [0, radius, radius, 0] : [radius, radius, 0, 0],
          },
          data: [],
        }
      }
      if (!this.chartData?.length) {
        return []
      }
      // 除第一列(维度)之外的所有表头key集合 keyList
      const colKeyList = Object.keys(this.chartData[0]).slice(1)
      // 表头
      const tableHeader = this.componentType === 'barPolar' ? '' : this.chartData[0]
      // 表格数据 (去除第一行(表头))
      const tableData = this.chartData.slice(1)
      // 遍历除第一列(维度)之外的所有列
      colKeyList.forEach(key => {
        // 排除空数据
        if (!tableData.every(row => (row[key] === '' || row[key] === undefined))) {
          list.push({
            ...initItem,
            name: tableHeader[key], // 当前数据列的表头
            data: tableData.map(bar => bar[key]), // 当前数据列
          })
        }
      })
      return list
    },
    columnName () {
      const list = []
      if (this.chartData.length) {
        const colKeyList = Object.keys(this.chartData[0])
        colKeyList.forEach(item => {
          if (this.chartData[1][item] !== '' && this.chartData[1][item] !== undefined) {
            list.push(this.chartData[0][item])
          }
        })
        return list.slice(1)
      } else {
        return []
      }
    },

  },
  watch: {
    // 数据变更时
    chartData: {
      handler: function (val) {
        this.init()
      },
      deep: true,
    },
    // 全局样式监听
    'globalConfig.chartColors': {
      handler () {
        // 主题颜色修改
        this.option.color = COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value
        this.charts.setOption(this.option, true)
      },
      deep: true,
    },
    // 配置项变更
    config: {
      handler: function () {
        this.init()
      },
      deep: true,
    },
    async borderStyle (val) {
      if (val) {
        this.borderImgUrl = await imgURLtoBase64(val)
      } else {
        this.borderImgUrl = ''
      }
    },
  },
  async created () {
    if (this.borderStyle) {
      this.borderImgUrl = await imgURLtoBase64(this.borderStyle)
    }
    if (this.componentType !== 'barPolar') {
      // 除极坐标外  初始化新增 圆角、宽度属性
      if (!this.style.chartStyle?.borderWidth) { this.$set(this.config.chartSet.chartStyle, 'borderWidth', 10) }
      if (!this.style.chartStyle?.borderRadius) { this.$set(this.config.chartSet.chartStyle, 'borderRadius', 10) }
      if (!this.style.chartStyle?.carouselDelay) { this.$set(this.config.chartSet.chartStyle, 'carouselDelay', 3) }
    }
    if (!this.style.chartStyle?.isLegend) { this.$set(this.config.chartSet.chartStyle, 'isLegend', false) }
    if (!this.style.chartStyle?.legendSize) { this.$set(this.config.chartSet.chartStyle, 'legendSize', 12) }
  },
  mounted () {
    if (!this.charts) {
      this.charts = echarts.init(this.$refs.barChart)
    }
    this.init()
  },
  methods: {
    init () {
      this.option = {
        color: COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value,

        tooltip: {
          textStyle: {
            color: '#fff',
            fontSize: this.style.chartStyle.fontSize,
          },
        },
      }
      // 根据不同类型设置echarts
      switch (this.componentType) {
        case 'horizonBar' : this.setHorizonOption()
          break
        case 'verticalBar': this.setVerticalOption()
          break
        case 'barPolar': this.setPolarOption()
          break
      }

      this.charts.setOption(this.option, true)

      // 是否轮播 tooltips
      if (this.style.chartStyle.carousel && this.series.length) {
        this.tooltipsActive()
        this.mouseEvents()
      } else {
        if (this.timer) {
          clearInterval(this.timer)
          this.charts.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: this.index,
          })
          this.index = -1
        }
      }
      // resize
      this.$nextTick(() => {
        this.charts.resize()
      })
    },

    // 纵向 柱状图
    setVerticalOption () {
      this.option = _.merge(_.cloneDeep(verticalBarBaseOption), {
        ...this.option,
        grid: {
          top: this.style.chartStyle.isLegend ? '40px' : '10%',
        },
        legend: {
          show: this.style.chartStyle.isLegend,
          textStyle: {
            fontSize: this.style.chartStyle.legendSize,
          },
        },
        xAxis: {
          data: this.dataAxis,
          axisLabel: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },
        yAxis: {
          axisLabel: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },

        series: this.series,
      })
    },

    // 横向 柱状图
    setHorizonOption () {
      this.option = _.merge(_.cloneDeep(horizonBarBaseOption), {
        ...this.option,
        legend: {
          show: this.style.chartStyle.isLegend,
          textStyle: {
            fontSize: this.style.chartStyle.legendSize,
          },
        },

        yAxis: {
          data: this.dataAxis,
          axisLabel: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },
        xAxis: {
          axisLabel: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },
        series: this.series,
      })
    },
    setPolarOption () {
      const currentRadius = [this.style.chartStyle.internalRadius + '%', this.style.chartStyle.externalRadius + '%']

      this.option = _.merge(_.cloneDeep(polarBarBaseOption), {
        ...this.option,
        legend: {
          show: this.style.chartStyle.isLegend,
          textStyle: {
            fontSize: this.style.chartStyle.legendSize,
          },
        },
        tooltip: {
          textStyle: {
            fontSize: this.style.chartStyle.fontSize,
          },
          formatter: (params) => {
            let category = null
            let str = ''
            params.forEach((item) => {
              category = item.name
              str += `<div style="display:inline-block; width: 10px;height: 10px;  border-radius:50px ;background-color: ${item.color};margin-right: 4px"></div> ${this.columnName[item.seriesIndex]}   <span style="margin-left: 10px; font-weight: 600">${item.data}</span><br>`
            })
            return category + '<br>' + str
          },
        },
        polar: {
          radius: currentRadius,
        },
        angleAxis: {
          max: this.style.chartStyle.max,
          axisLabel: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },
        radiusAxis: {
          data: this.dataAxis,
          axisLabel: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },
        series: this.series,
      })
    },

  },
}
</script>

<style lang='scss' scoped>
  .bar-chart{
    display: flex;
    flex-direction: column;
    &-wrapper {
      position: relative;
      width:100%;

    }
    &-border {
      position: absolute;
      top: 0;
      height: 100%;
      z-index: -1;

    }
    &-title {
      padding:7px 30px;
    }
    .bar-chart-container{
      flex: 1;
    }
  }
  </style>
